// src/pages/Sobre.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './Sobre.css';

const Sobre = () => {
  return (
    <main className="page-about">

      {/* Seção 1: About us */}
      <section className="about-us-section">
        <div className="page-content">
          <h1>As pessoas por trás da CODI</h1>
          <p>representam experiência no universo dos <strong>negócios, educação e tecnologia.</strong></p>
        </div>
      </section>
      {/* About us */}

      {/* Seção 1: Who we are */}
      <section className="who-we-are-section">
        <div className="page-content">

          <div className="people-container">

            <div className="person-container">
              <div className="person-image joao"></div>
              <div className="person-name">João Pedroso <span className="person-role">Investidor</span></div>
              <div className="person-description">
                Empreendedor desde 1984, João é o fundador do grupo Guararapes, Indústria de Painéis de Madeira.
                Também está por trás de empreendimento de geração de energia elétrica, sendo responsável por gerar
                mais de 200.000 MWh/ano. Administração de bens com a RDT Participações Societárias, Locação de imóveis,
                com o Autoshopping e PBshopping e construção civil com a Itagiba empreendimentos.
                Em 1999 começou a se relacionar com o ramo da educação, fundando a instituição FADEP,
                que em 2018 foi vendida para o grupo Afya. Na ocasião da venda, a Plataforma CODI se tornou
                uma spin-off da Instituição.
              </div>
            </div>

            <div className="person-container">
              <div className="person-image luiz"></div>
              <div className="person-name">Luiz Ricardo <span className="person-role">CEO</span></div>
              <div className="person-description">
                Luiz Ricardo é engenheiro de materiais com especialização em Engenharia de Produção pela UFSC,
                iniciando a carreira no setor industrial em 1984. Desde 1997 atua como gestor com ênfase nas áreas
                de custos, processos, qualidade e finanças na área educacional. Já atuou como professor e se
                familiarizou com o novo universo por meio de projetos pedagógicos, metodologias de aprendizagem,
                relação aluno-professor-IES, processos de avaliação. Posteriormente, atuando na integração das
                áreas administrativa e financeira com a educacional, apaixonou-se pelo tema do combate à evasão
                escolar e universitária.
              </div>
            </div>

            <div className="person-container">
              <div className="person-image andre"></div>
              <div className="person-name">André Mendes <span className="person-role">CTO</span></div>
              <div className="person-description">
                Entre exatas e humanas, André é mestre em Ciência da Computação. Acredita que os números dizem
                muito e que o desafio é construir tecnologias que ajudem a interpretá-los corretamente. No
                ensino superior, conhece a sala de aula como professor e também como coordenador de tecnologia
                da informação. Tem experiência com infraestrutura, otimização de recursos e desenvolvimento
                de sistemas. Na CODI, o André encontrou a oportunidade de unir todos estes conhecimentos ao desenvolver
                as funcionalidades de inteligência educacional da plataforma.
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* Who we are */}

      {/* CTA ao final */}
      <section className="about-cta-section">
        <h2 className="section-subtitle">Junte-se a nós na missão de transformar a educação</h2>
        <Link to="/contato" className="btn btn-primary">Converse com nossa equipe</Link>
      </section>

    </main>
  );
};

export default Sobre;
